import {forwardRef, useState} from "react";
import { Eye, X } from "react-feather";
import TextFieldLabel from "./TextFieldLabel";
import "./TextInput.scss";

const TextInput = forwardRef(({ name, size, width, fullWidth, inputClassName, className, label, invalid, helperText, disabled, icon, type, placeholder, onChange, clearText, isClearable, variant, showPasswordToggle, ...rest }, ref) => {
	const [value, setValue] = useState("")
	const [toggleType, setToggleType] = useState(false);
	const clearIconVisible = isClearable && value && value !== "";
	const eyeIconVisible = /*type && type === "password" ||*/ showPasswordToggle;

	return (
		<div
			className={`text-input-wrapper${invalid ? " text-input-wrapper-invalid" : ""}${icon ? " icon-active" : ""}${isClearable ? " clear-icon-active" : ""}${
				size === "small" ? " text-input-small" : ""
			}${className ? " " + className : ""}${width ? " text-field-width-" + width : ""}${fullWidth ? " input-full-width" : ""}`}
			style={rest.style}
		>
			{label && <TextFieldLabel>{label}</TextFieldLabel>}
			<input
				onChange={(e) => {
					setValue(e.target.value);
					onChange(e);
				}}
				onKeyDown={rest.onKeyDown}
				ref={ref}
				{...rest}
				type={/*toggleType && type === "password" ? "text" : type && !toggleType ?*/ type || "text"}
				name={name}
				disabled={disabled}
				placeholder={placeholder}
				className={`text-input${size === "small" ? " input-size-small" : ""}${inputClassName ? " " + inputClassName : ""}${variant === "light" ? " input-variant-light" : variant === "bordered-light" ? " input-variant-bordered-light" : ""}`}
				style={rest.inputstyle && showPasswordToggle ? toggleType ? rest.inputstyle : { ...rest.inputstyle, fontFamily: 'text-security-disc', '-webkit-text-security': 'disc', 'text-security': 'disc' } : rest.inputstyle}
			/>
			<div style={rest.iconstyle ? rest.iconstyle : null} className="text-field-icon-wrapper">{icon && icon}</div>
			{clearIconVisible && <X className="clear-icon" onClick={() => { clearText(); setValue("")}} />}
			{eyeIconVisible && <Eye className={`view-password-icon${toggleType ? " active" : ""}${invalid ? " invalid" : ""}`} onClick={() => setToggleType(!toggleType)} style={rest?.eyeIconStyle}/>}
			{helperText && <div className={rest.helperTextClass ? rest.helperTextClass : "text-input-helper-text"}>{helperText}</div>}
		</div>
	);
})

export default TextInput 